import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@roger/ui-components';
import { IMPORTED_FETCH_RETRY_LABEL } from './importedChartLineCopy';

/**
 * The imported sibling failed to load, said where the section would sit.
 *
 * Silence was the pre-ruling behavior, and it hid the interaction-screening
 * notice with it — a patient with unreconciled lines read identically to one
 * with none. The strip names the absence and carries the retry; the coded
 * list below it stays untouched, because an outage on the imported sibling
 * must never blank the records a clinician actually needs.
 */
const ImportedFetchErrorNotice: React.FC<{
  copy: string;
  onRetry: () => void;
}> = ({ copy, onRetry }) => (
  <div
    className='mb-4 rounded-md border border-red-200 bg-red-50 p-3'
    data-testid='imported-fetch-error'
  >
    <div className='flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between'>
      <div className='flex gap-2'>
        <AlertTriangle className='h-4 w-4 shrink-0 text-red-600 mt-0.5' />
        <p className='text-sm text-red-900'>{copy}</p>
      </div>
      <Button
        size='sm'
        variant='outline'
        onClick={onRetry}
        className='self-start sm:self-auto'
        data-testid='imported-fetch-retry'
      >
        {IMPORTED_FETCH_RETRY_LABEL}
      </Button>
    </div>
  </div>
);

export default ImportedFetchErrorNotice;
